import { render, staticRenderFns } from "./IdentificationConfirmation.vue?vue&type=template&id=7a8721ba"
import script from "./IdentificationConfirmation.vue?vue&type=script&lang=ts"
export * from "./IdentificationConfirmation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports